export default __webpack_public_path__ + "static/media/GoNoGoIntroImg.4dc359f9.svg";